import { Element } from '@api/models/Element'

export class ExpertRatingsDataHelper {

    /**
     * Фильтрует список по наличию индивидуальных критериев - если есть хотя-бы один индивидуальный,
     * то возавращает список только с индивидуальными критериями
     * @param list исходный список критериев
     */
    static prepareCommonCriteria(list: Element[]): Element[] {

        const hasIndividual = list.some((criterion => criterion.sectionId));

        if (hasIndividual) {
            return list.filter((criterion => criterion.sectionId));
        }

        return list;
    }
}